// buttonStylesJson.js

const buttonStylesJson = [
  {
    id: 'style1',
    label: 'buttonStyle1',
    style: {
      width: '80px',
      height: '33px',
      padding: '8px 16px',
      border: '1px solid',
      borderRadius: '0px',
    },
  },
  {
    id: 'style2',
    label: 'buttonStyle2',
    style: {
      width: '80px',
      height: '33px',
      padding: '8px 16px',
      borderRadius: '4px',
      border: '1px solid',
    },
  },
  {
    id: 'style3',
    label: 'buttonStyle3',
    style: {
      width: '80px',
      height: '33px',
      padding: '8px 16px',
      borderRadius: '10px',
      border: '1px solid',
    },
  },
  {
    id: 'style4',
    label: 'buttonStyle4',
    style: {
      width: '80px',
      height: '33px',
      padding: '8px 16px',
      borderRadius: '20px',
      border: '1px solid',
    },
  },
];

export default buttonStylesJson;
